import { NavLink } from 'react-router-dom'
import '../css/main.css'

function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{ background: '#080808' }}
    >
      {/* Teal line grid — fades toward edges like the scroll indicator */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `
            linear-gradient(rgba(45,212,191,0.06) 1px, transparent 1px),
            linear-gradient(90deg, rgba(45,212,191,0.06) 1px, transparent 1px)
          `,
          backgroundSize: '60px 60px',
          WebkitMaskImage: 'radial-gradient(ellipse 85% 75% at 50% 48%, black 10%, transparent 72%)',
          maskImage: 'radial-gradient(ellipse 85% 75% at 50% 48%, black 10%, transparent 72%)',
        }}
      />

      {/* Ambient glow — top right */}
      <div
        className="absolute pointer-events-none"
        style={{
          top: '-10%',
          right: '-5%',
          width: '550px',
          height: '550px',
          background: 'radial-gradient(circle, rgba(45,212,191,0.10) 0%, transparent 65%)',
          borderRadius: '50%',
        }}
      />

      {/* Ambient glow — bottom left */}
      <div
        className="absolute pointer-events-none"
        style={{
          bottom: '-10%',
          left: '-5%',
          width: '450px',
          height: '450px',
          background: 'radial-gradient(circle, rgba(45,212,191,0.07) 0%, transparent 65%)',
          borderRadius: '50%',
        }}
      />

      {/* Left decorative line */}
      <div
        className="absolute hidden lg:block"
        style={{
          left: '40px',
          top: '30%',
          bottom: '30%',
          width: '1px',
          background: 'rgba(255,255,255,0.07)',
        }}
      />

      {/* Center content */}
      <div
        className="relative z-10 w-full flex flex-col items-center text-center"
        style={{ padding: '100px 80px 80px', paddingRight: 'clamp(80px, 8vw, 120px)' }}
      >
        {/* Eyebrow */}
        <p
          className="text-teal-400 uppercase font-medium"
          style={{ fontSize: '10px', letterSpacing: '0.35em', marginBottom: '48px' }}
        >
          Architecture · Engineering · Construction
        </p>

        {/* Headline */}
        <h1
          style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontWeight: 300,
            lineHeight: 1.0,
            marginBottom: '36px',
          }}
        >
          <span
            className="block text-white"
            style={{ fontSize: 'clamp(3.2rem, 7.5vw, 9rem)' }}
          >
            Turning Vision
          </span>
          <span
            className="block"
            style={{ fontSize: 'clamp(3.2rem, 7.5vw, 9rem)' }}
          >
            <span className="text-white">Into </span>
            <span
              className="italic"
              style={{ color: '#2dd4bf' }}
            >
              Enduring
            </span>
          </span>
          <span
            className="block"
            style={{
              fontSize: 'clamp(3.2rem, 7.5vw, 9rem)',
              color: 'transparent',
              WebkitTextStroke: '1px rgba(255,255,255,0.4)',
            }}
          >
            Realities.
          </span>
        </h1>

        {/* Subtitle */}
        <p
          className="font-light leading-relaxed"
          style={{
            color: 'rgba(255,255,255,0.45)',
            fontSize: '14px',
            maxWidth: '500px',
            marginBottom: '44px',
          }}
        >
          EDGES Design Group delivers architecture, engineering, interior design, and
          construction solutions crafted for modern living, commercial excellence, and
          sustainable development across Rwanda and East Africa.
        </p>

        {/* CTAs */}
        <div className="flex flex-nowrap items-center" style={{ gap: '16px' }}>
          <NavLink
            to="/projects"
            className="uppercase font-medium text-black bg-teal-400 transition-all duration-200"
            style={{ padding: '14px 36px', fontSize: '11px', letterSpacing: '0.15em' }}
            onMouseEnter={e => (e.currentTarget.style.background = '#5eead4')}
            onMouseLeave={e => (e.currentTarget.style.background = '#2dd4bf')}
          >
            View Our Projects
          </NavLink>
          <NavLink
            to="/contacts"
            className="hidden sm:inline-flex uppercase font-medium text-white transition-all duration-200"
            style={{
              padding: '14px 36px',
              fontSize: '11px',
              letterSpacing: '0.15em',
              border: '1px solid rgba(255,255,255,0.2)',
            }}
            onMouseEnter={e => (e.currentTarget.style.borderColor = 'rgba(255,255,255,0.55)')}
            onMouseLeave={e => (e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)')}
          >
            Get in Touch
          </NavLink>
        </div>
      </div>


      {/* Bottom scroll indicator */}
      <div
        className="absolute left-1/2 flex flex-col items-center"
        style={{ bottom: '32px', transform: 'translateX(-50%)', gap: '10px' }}
      >
        <p
          className="uppercase"
          style={{ fontSize: '8px', letterSpacing: '0.35em', color: 'rgba(255,255,255,0.22)' }}
        >
          Scroll
        </p>
        <div
          style={{
            width: '1px',
            height: '40px',
            background: 'linear-gradient(to bottom, rgba(255,255,255,0.22), transparent)',
          }}
        />
      </div>
    </section>
  )
}

export default Hero
